import { motion } from "framer-motion";
import { KineticLines } from "./Reveal";

export const PageHeader = ({ eyebrow, titleLines, description }) => (
  <section className="relative pt-36 sm:pt-44 pb-16 sm:pb-20 bg-[#0A0A0A] overflow-hidden">
    <div className="absolute inset-0 grid-lines opacity-30" />
    <div className="absolute -top-20 -right-20 w-[500px] h-[500px] bg-[#5CC528]/10 rounded-full blur-[130px]" />
    <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="flex items-center gap-3 mb-6"
      >
        <span className="h-px w-10 bg-[#5CC528]" />
        <span className="text-[#5CC528] text-xs sm:text-sm uppercase tracking-[0.25em]">{eyebrow}</span>
      </motion.div>
      <h1 className="font-display font-light text-5xl sm:text-7xl lg:text-8xl tracking-tighter leading-[0.92] text-white">
        <KineticLines lines={titleLines} />
      </h1>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="mt-8 text-neutral-400 text-lg max-w-2xl leading-relaxed"
        >
          {description}
        </motion.p>
      )}
    </div>
  </section>
);
